module.exports = __webpack_public_path__ + "static/img/login_email.5124955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_email.png
// module id = Mp1m
// module chunks = 1